import { useLocation } from '@okapi/router-react';
import React, { ComponentType, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useIsomorphicLayoutEffect } from 'common/hooks';
import { useAction } from 'common/hooks/use-action';
import { fetchModel, fetchModelReset } from '../store/actions';
import { getPageModelIsLoading } from '../store/selectors';

export function withModel<P>(Component: ComponentType<P>): React.FC<P> {
  const hoc: React.FC<P> = props => {
    /* eslint-disable react-hooks/rules-of-hooks  */
    const [path] = useLocation();
    const prevPath = useRef(path);

    const isLoading = useSelector(getPageModelIsLoading);

    const refetch = useAction(fetchModel.request);
    const reset = useAction(fetchModelReset);

    useEffect(() => {
      if (prevPath.current !== path && !isLoading) {
        prevPath.current = path;
        refetch();
      }
    }, [isLoading, refetch, path]);

    useIsomorphicLayoutEffect(
      () => () => {
        reset();
      },
      []
    );
    /* eslint-enable react-hooks/rules-of-hooks */

    return <Component {...props} />;
  };
  return hoc;
}
